import './components/public-path';
import selectCountry from './components/select-country';
import drawer from './components/drawer';
import header from './components/header';
import animations from './components/animations';
import slider from './components/slider';
import products from './components/products';
import product from './components/product';
import tooltip from './components/tooltip';
import collapsable from './components/collapsable';
import print from './components/print';
import errorPage from './components/error-page';
import form from './components/form';
import tab from './components/tab';

selectCountry();
drawer();

function offsetAnchor() {
    const { hash } = window.location;

    if (hash) {
        const target = document.querySelector(hash);
        if (target) {
            requestAnimationFrame(() => {
                const elementTop = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: elementTop - 160,
                    behavior: 'instant',
                });
            });
        }
    }
}

// Handle hashchange (clicks, internal links)
window.addEventListener('hashchange', offsetAnchor);

// Handle full page load
window.addEventListener('load', offsetAnchor);

header();
animations();
slider();
products();
product();
tooltip();
collapsable();
print();
errorPage();
form();
tab();
